/* eslint-disable react/prop-types */
/* eslint "react/no-multi-comp": "off" */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import find from 'lodash/find';
import store from 'router/store';
import { getCachedQueryString } from 'utils/localRepository';
import { addBdsTrackingFields } from 'utils/bdsTracking';
import { track } from 'actions/analytics';
import { createPageDataEmitter } from 'utils/analytics/pageDataUtils';

const shouldTrackUpgradePath = (pathname = '') => !pathname.endsWith('/loan');

const emitUpgradePageData = createPageDataEmitter(
  () => store.dispatch(track('page_data', {}, 'new')),
  shouldTrackUpgradePath,
);

export const routeApplicationPart = (WrappedComponent, stepType, shouldTrackPageData = false) => {
  class ApplicationStepWrapper extends Component {
    componentDidMount() {
      const {
        loan, loanFormSetStep, pushGaStepEvent, resetClick2Call,
      } = this.props;
      const { steps } = loan;
      const step = find(steps, (item) => item.type === stepType);
      const index = steps.indexOf(step);
      const isIncreaseStatusStep = INCREASE_APP && stepType === 'SCORING_STATUS_AU';

      if (index !== loan.currentStep && stepType !== 'SCORING_STATUS' && !isIncreaseStatusStep) {
        loanFormSetStep(index);
      } else {
        if (pushGaStepEvent && step.analyticsStepName) {
          pushGaStepEvent(step.analyticsStepName);
        }
        if (step.click2CallAvailable) {
          resetClick2Call();
        }
        if (shouldTrackPageData) {
          emitUpgradePageData(
            store.getState().authentication?.isAuthenticated,
            window.location.pathname,
          );
        }
      }

      if (COUNTRY === 'MX') {
        addBdsTrackingFields('loan-form', loan.session_uuid);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return ApplicationStepWrapper;
};

export const routeOfferPart = (WrappedComponent, stepType, preventLeave = true, shouldTrackPageData = false) => {
  class OfferStepWrapper extends Component {
    constructor(props) {
      super(props);
      this.routerWillLeave = this.routerWillLeave.bind(this);
    }

    componentDidMount() {
      const {
        loan,
        authentication,
        route,
        router,
        loanFormSetStep,
        pushGaStepEvent,
        resetClick2Call,
      } = this.props;
      const { steps } = loan;
      if (authentication.isAuthenticated) {
        router.setRouteLeaveHook(route, this.routerWillLeave);
      }
      const step = find(steps, (item) => item.type === stepType);
      const index = steps.indexOf(step);
      if (index !== loan.currentStep && authentication.isAuthenticated) {
        loanFormSetStep(index);
      } else {
        if (pushGaStepEvent && step.analyticsStepName) {
          pushGaStepEvent(step.analyticsStepName);
        }
        if (step.click2CallAvailable) {
          resetClick2Call();
        }
        if (shouldTrackPageData) {
          emitUpgradePageData(
            store.getState().authentication?.isAuthenticated,
            window.location.pathname,
          );
        }
      }
    }

    routerWillLeave(nextLocation) {
      if (!preventLeave) {
        return true;
      }

      const storeState = store.getState();
      const {
        authentication: { isAuthenticated },
        loan: { verifyOptions },
      } = storeState;

      const isLeaveDisabled = nextLocation.action !== 'PUSH' && nextLocation.action !== 'REPLACE' && isAuthenticated;

      if (INSTANTOR_ENABLED && stepType === 'ONE_CENT') {
        if (isLeaveDisabled && verifyOptions === 'instantor') {
          return false;
        }
      } else if (isLeaveDisabled) {
        return false;
      }

      return true;
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return withRouter(OfferStepWrapper);
};

export const privateRoute = (WrappedComponent, shouldTrackPageData = false) => {
  class PrivateRouterWrapper extends Component {
    constructor() {
      super();
      this.redirectToLogin = this.redirectToLogin.bind(this);
    }

    componentDidMount() {
      if (shouldTrackPageData) {
        emitUpgradePageData(this.props.authentication.isAuthenticated, window.location.pathname);
      }
    }

    UNSAFE_componentWillMount() {
      if (!this.props.authentication.isAuthenticated) {
        this.redirectToLogin();
      }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.authentication.redirectURL) {
        window.location.assign(nextProps.authentication.redirectURL);
        return;
      }

      if (
        this.props.authentication.isAuthenticated
        && !nextProps.authentication.isAuthenticated
      ) {
        this.redirectToLogin();
      }
    }

    redirectToLogin() {
      let search = location.search;
      if (COUNTRY === 'FI') {
        search = getCachedQueryString(true) || search;
      }
      this.props.router.replace(`/login${search}${location.hash}`);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return withRouter(PrivateRouterWrapper);
};
